
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12091',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12091",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.461",
  "dashboard-client-types": "static-1.351",
  "data-fetching-client": "static-1.9632",
  "foundations-components": "static-1.7844",
  "foundations-components-legacy": "static-1.869",
  "foundations-theming": "static-1.4374",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7974",
  "hub-http-shared-msw-handlers": "static-1.9854",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11419",
  "I18n": "static-7.1612",
  "jasmine-runner": "static-1.6427",
  "marketplace-storefront-base": "static-1.12152",
  "quartz": "static-1.6964",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16626",
  "reactive-variable-buffer-atom": "static-1.2817",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.42",
  "settings-ui-lib": "static-1.12479",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7050",
  "ui-addon-i18n": "static-1.11108",
  "ui-addon-react-router-dom": "static-1.9503",
  "unified-auth": "static-1.435",
  "unified-auth-core-lib": "static-1.716",
  "usage-tracker": "static-1.7297",
  "usage-tracker-core": "static-1.7147",
  "customer-data-property-utils": "static-1.8041",
  "hub-http": "static-1.6179",
  "integrations-lib": "static-1.15963",
  "marketplace-ui-common": "static-1.19534",
  "property-management-iframe": "static-1.12992",
  "quartz-config": "static-1.742",
  "quartz-core": "static-1.6183",
  "quartz-routing": "static-1.394",
  "quick-fetch": "static-1.3881",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4608",
  "ts-schema": "static-1.4042",
  "ui-universal-auth": "static-1.8921",
  "UIComponents": "static-3.8366",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3368",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3241",
  "quartz-webpack": "static-1.3188",
  "bend-plugin-quartz-routing": "static-1.42",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4113",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4814",
  "foundations-theming-specialty": "static-1.2090",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9387",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.11",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5308",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1710",
  "ui-fonts": "static-1.681",
  "ui-images": "static-2.1141",
  "bend-plugin-foundations-theming": "static-1.2857",
  "foundations-theming-base": "static-1.3359",
  "stylex": "static-1.32",
  "HeadJS": "static-2.741",
  "hs-test-utils-bend-plugin": "static-1.3085",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4282",
  "ai-components-ui-library": "static-1.8812",
  "ai-rendering-library": "static-1.9938",
  "chirp-fetch": "static-1.1843",
  "connections-embed-lib": "static-1.910",
  "copilot-toolkit": "static-1.10991",
  "feedback-loader": "static-1.29213",
  "laboratory-lib": "static-3.7116",
  "marketplace-embed": "static-1.21932",
  "marketplace-ui-details": "static-1.9430",
  "marketplace-ui-reviews": "static-1.19490",
  "marketplace-ui-tracking": "static-1.13705",
  "sanitize-text": "static-1.8101",
  "ui-addon-video-player": "static-1.8656",
  "usage-tracker-multi": "static-1.5711",
  "usage-tracker-session-replay": "static-1.4983",
  "wootric-nps": "static-1.6943",
  "quartz-head": "static-1.629",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4606",
  "immer": "static-1.33",
  "immerable": "static-1.4111",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2472",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.42",
  "cssUtils": "static-1.780",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11727",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10168",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10329",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7287",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18067",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4473",
  "foundations-components-test-utils": "static-1.5327",
  "quartz-i18n": "static-1.639",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.94",
  "microsoft-drive-integration-lib": "static-1.207",
  "fsm": "static-1.3690",
  "customer-data-objects": "static-1.7621",
  "property-translator": "static-1.5359",
  "hs-locale-management": "static-1.48",
  "frontend-preferences-client": "static-1.7885",
  "hs-promise-utils": "static-1.5551",
  "hubspot-apollo-client": "static-1.4834",
  "integrations-error-boundary-lib": "static-1.13378",
  "integrations-tracking-lib": "static-1.5556",
  "native-integrations-shared-strings": "static-1.7741",
  "reselect": "static-2.16",
  "sanitize": "static-1.4430",
  "superstore": "static-1.4724",
  "ui-shepherd-react": "static-3.10106",
  "ai-settings-ui-library": "static-1.7811",
  "hub-http-janus": "static-1.827",
  "hubspotter-http": "static-1.4616",
  "immutable-less": "static-1.4607",
  "marketplace-ui-client-types": "static-1.16941",
  "nav-meta": "static-1.29509",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10203",
  "ui-addon-upgrades": "static-9.17923",
  "inbound-db-properties-service-client": "static-1.3805",
  "property-management-common": "static-1.5280",
  "ui-addon-iframeable": "static-1.9013",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.639",
  "quartz-test": "static-1.639",
  "quartz-tracking": "static-1.343",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.18",
  "bender-build-tools": "static-1.3123",
  "inbound-db-meta-service-client": "static-1.3555",
  "persist-promise": "static-1.3664",
  "reference-resolvers": "static-1.8128",
  "transmute": "static-2.85",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21056",
  "ContentUtils": "static-1.68222",
  "customer-data-objects-ui-components": "static-1.12983",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2456",
  "customer-data-filters-ui": "static-1.39581",
  "customer-data-reference-ui-components": "static-1.13117",
  "embedded-academy-lib": "static-1.14176",
  "ExportDialog": "static-6.10351",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41171",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.42",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.42",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.42",
  "ui-addon-teams": "static-1.21488",
  "magpie-lib": "static-1.5532",
  "navigation-components": "static-1.17872",
  "magpie-types": "static-1.4992",
  "simple-logging-lib": "static-1.3007",
  "ai-studio-lib": "static-1.11459",
  "app-governance-lib": "static-1.1387",
  "developer-experience-shared-components": "static-1.10467",
  "ui-addon-integrations-directory-panel": "static-2.7954",
  "ui-product-approvals": "static-1.28005",
  "ui-tool-access": "static-1.10107",
  "usage-based-billing-components-lib": "static-1.8637",
  "usage-tracker-anonymous": "static-1.5714",
  "usage-tracker-public": "static-1.7108",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3886",
  "hubspot-apollo-cache": "static-1.293",
  "universal-page-editor-lib": "static-1.2970",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2640",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5030",
  "purchase-motions-components": "static-1.5801",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1507",
  "crm-component-utils": "static-1.38950",
  "crm-properties-common-lib": "static-1.5834",
  "customer-data-properties": "static-1.51378",
  "framework-data-schema-resolvers": "static-1.6836",
  "property-value-citations": "static-1.1992",
  "reference-resolvers-lite": "static-1.8053",
  "navigation-messaging": "static-1.7199",
  "hubspotter-http-shared-msw-handlers": "static-1.9852",
  "growth-payments-core": "static-1.25225",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13534",
  "conversations-skeleton-state": "static-1.7206",
  "crm-message-bus": "static-1.42856",
  "reporting-plugins": "static-1.10214",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.42",
  "cms-field-types": "static-1.4769",
  "content-icons-ui": "static-1.2214",
  "customer-data-ui-utilities": "static-1.9784",
  "customer-data-filters-ui-msw-helpers": "static-1.22016",
  "FormUrlGenerator": "static-2.4677",
  "framework-builder-read-service-client": "static-1.3974",
  "framework-data-schema-quick-fetch": "static-1.6741",
  "multi-account-reference-resolvers": "static-1.937",
  "onboarding-tours": "static-1.16509",
  "academy-common-lib": "static-1.13636",
  "content-assistance-lib": "static-1.7681",
  "dashboard-lib": "static-1.81334",
  "file-manager-components": "static-1.23487",
  "getting-started-shared-tasks": "static-1.18360",
  "hubspot-prosemirror": "static-1.18098",
  "hubspot-prosemirror-plugins": "static-1.18090",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19751",
  "share-with-third-party-component-lib": "static-1.8655",
  "ui-addon-draggable": "static-3.4727",
  "ui-asset-management-lib": "static-1.10966",
  "ui-business-units-lib": "static-1.9006",
  "user-context": "static-1.5059",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.679",
  "nest": "static-1.185",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10581",
  "framework-listing-lib": "static-2.28542",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30589",
  "apps-service-types": "static-1.3835",
  "oauth-service-types": "static-1.4207",
  "onboarding-scopes": "static-1.6420",
  "onboarding-tours-client": "static-1.4723",
  "platform-infra-nav-components": "static-1.7637",
  "subscription-experience-data-types": "static-1.14857",
  "crm-record-cards-service-types": "static-1.3574",
  "location-customization-utils-lib": "static-1.9100",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5804",
  "signup-constants": "static-1.18758",
  "signup-ui-url-generator": "static-2.7998",
  "trials-service-types": "static-1.3861",
  "card-properties-lib": "static-1.44029",
  "commerce-subscription-lib": "static-1.36959",
  "crm-actions": "static-1.6277",
  "crm-cards-sdk": "static-1.43436",
  "customer-data-properties-shared-msw-handlers": "static-1.9181",
  "customer-data-tracking": "static-1.6843",
  "hs-resources": "static-1.106",
  "pulse": "static-1.518",
  "calling-global-api": "static-1.64343",
  "calling-internal-common": "static-1.31259",
  "calling-lifecycle-internal": "static-1.65725",
  "calling-lifecycle-messages": "static-1.58019",
  "commerce-products-lib": "static-1.9352",
  "conditional-properties-service-client": "static-1.3761",
  "crm-links": "static-1.6241",
  "external-options-client-types": "static-1.4123",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4188",
  "meetings-icalendar-utils-lib": "static-1.589",
  "multi-currency-client-types": "static-1.3656",
  "object-builder-ui-client": "static-1.48572",
  "pipeline-validation-client-types": "static-1.3930",
  "smart-property-lib": "static-1.6689",
  "tiered-pricing": "static-1.1113",
  "ui-addon-form-validation": "static-1.10946",
  "crm-pipelines-api-client-types": "static-1.4107",
  "ui-addon-opt": "static-4.8330",
  "campaign-roi-lib": "static-1.8934",
  "react-dnd-compat": "static-1.4578",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5354",
  "growth-onboarding-confetti": "static-1.3025",
  "growth-onboarding-next-action-utils": "static-1.1772",
  "onboarding-tours-utils": "static-1.575",
  "ui-shepherd-tracker": "static-1.7487",
  "academy-service-client": "static-1.3640",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.38986",
  "FileManagerLib": "static-1.39127",
  "video-embed": "static-1.35601",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28409",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11109",
  "video-data-lib": "static-1.34767",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23399",
  "ui-addon-emoji-picker": "static-1.9846",
  "EmailSignatureEditor": "static-1.24272",
  "viral-links-lib": "static-1.7013",
  "data-token-picker": "static-1.16324",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.183",
  "timezone-utils": "static-2.5202",
  "getting-started-shared-tasks-store": "static-1.17478",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7283",
  "customer-data-views-management": "static-1.25361",
  "framework-data-table": "static-2.11811",
  "marketing-platform-lib": "static-1.6809",
  "nudge-client-utils": "static-1.2458",
  "nudge-custom-ui-functions": "static-1.951",
  "app-users-service-client": "static-1.5551",
  "app-users-service-types": "static-1.4959",
  "mini-checkout-client": "static-1.26687",
  "onboarding-utils": "static-1.5309",
  "permissions-shared-i18n-strings-fe": "static-1.2042",
  "ui-coaching-tips-shared-config": "static-1.28394",
  "edison-service-client-types": "static-1.344",
  "crm_data": "static-4.91803",
  "customer-data-sidebar": "static-2.45863",
  "enrichment-properties-lib": "static-1.15807",
  "commerce-billing-lib": "static-1.18928",
  "commerce-shared-components-lib": "static-1.18381",
  "commerce-tools-ui-lib": "static-1.10245",
  "crm-fe-perf": "static-1.22861",
  "bend-plugin-pulse": "static-1.21",
  "directed-graph": "static-1.893",
  "event-emitter": "static-1.906",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31265",
  "shared-worker-versioning": "static-1.10995",
  "calling-usage-tracker": "static-1.6500",
  "voice-sms-access-library": "static-1.793",
  "commerce-permissions": "static-1.723",
  "products-iframe-lib": "static-1.7787",
  "products-ui-components-shared-msw-handlers": "static-1.10236",
  "data-agent-kit": "static-1.120",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9937",
  "policy-lib": "static-1.6730",
  "react-tinymce": "static-1.55105",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10000",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54231",
  "tinymce-plugins": "static-1.57345",
  "tinymce-themes": "static-1.56201",
  "onboarding-data-sync-lib": "static-1.1885",
  "growth-onboarding-next-action-components": "static-1.1800",
  "user-context-client": "static-1.4568",
  "audio-components": "static-1.5846",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36638",
  "urlinator": "static-1.4489",
  "video-components": "static-1.13112",
  "outpost": "static-1.4145",
  "growth-onboarding-feedback-components": "static-1.6541",
  "content-media-composition-data-lib": "static-1.12089",
  "content-media-compositions": "static-2.16096",
  "media-bridge-lib": "static-1.18847",
  "commerce-tours-lib": "static-1.6008",
  "growth-onboarding-reliability": "static-1.5039",
  "sales-checkout-service-client": "static-1.3597",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21591",
  "sales-email-signature-service-client": "static-1.3801",
  "ts-utils-lib": "static-1.131",
  "crm-export-dialog": "static-1.6256",
  "crm-index-associations-lib": "static-1.6396",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1850",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2215",
  "nudge-renderer-utils": "static-1.2534",
  "whisper-core-api": "static-1.6468",
  "InboxConnectUtils": "static-4.14666",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5397",
  "settings-content-modals": "static-1.45938",
  "crm_universal": "static-1.21926",
  "customer-data-email": "static-1.17953",
  "card-payment-highlight-lib": "static-1.37024",
  "card-subscription-highlight-lib": "static-1.39382",
  "commerce-contract-lib": "static-1.11881",
  "invoices-highlight-card-lib": "static-1.54559",
  "orders-highlight-card-lib": "static-1.21325",
  "products-highlight-card-lib": "static-1.17636",
  "quotes-highlight-card-lib": "static-1.71812",
  "crm-source-interpretation-lib": "static-1.5296",
  "utility-belt": "static-1.2495",
  "payments-enrollment-embed-lib": "static-1.22547",
  "stripe-embedded-components": "static-1.7421",
  "customer-data-rte": "static-1.32870",
  "cv-backend-services": "static-1.1551",
  "growth-onboarding-empty-states": "static-1.5633",
  "payments-post-enroll-local-storage-lib": "static-1.5067",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37902",
  "calling-orchestration-schema": "static-1.35570",
  "sales-views-client-types": "static-1.4222",
  "hub-http-contrib": "static-1.2998",
  "interframe": "static-3.4719",
  "tinymce-data": "static-1.40316",
  "ui-addon-sales-email": "static-1.5168",
  "layout-dnd-components": "static-1.12355",
  "layout-dnd-utils": "static-1.11330",
  "ui-brand-identity-lib": "static-1.15041",
  "NamespacedHubStyle": "static-2.9027",
  "social-insights-client-types": "static-1.21954",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1854",
  "checkout-sdk": "static-3.23530",
  "checkout-service-types": "static-1.3791",
  "company-details-components": "static-1.6154",
  "payment-method-components": "static-1.6870",
  "pricing-pages-ui-components": "static-1.13656",
  "quote-checkout-service-types": "static-1.3438",
  "upgrade-catalog-service-types": "static-1.3482",
  "access-control-lib": "static-1.10395",
  "EmailComponents": "static-1.54634",
  "EmailData": "static-1.53311",
  "redux-less": "static-2.9441",
  "sequences-lib": "static-1.7960",
  "ui-gdpr-components": "static-1.10305",
  "products-ui-components": "static-1.39871",
  "accounting-integrations-ui-components": "static-1.6988",
  "invoices-ui-lib": "static-1.54575",
  "commerce-products-api": "static-1.2220",
  "invoices-iframe-lib": "static-1.56633",
  "quotes-modal-lib": "static-1.102490",
  "quotes-ui-lib": "static-1.80533",
  "stripe-connect-js": "static-1.67",
  "draft-content-plugins": "static-1.28138",
  "ContentData": "static-1.68297",
  "layout-data-lib": "static-1.9655",
  "hub-http-rxjs": "static-1.793",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3890",
  "billing-payments-client-types": "static-1.3948",
  "react-performance-metrics-lib": "static-1.516",
  "account-and-billing-fintech-outages": "static-3.18511",
  "pricing-pages-api": "static-1.13521",
  "ContentComponents": "static-2.71178",
  "marketing-contacts-lib": "static-1.9810",
  "marketing-email-service-types": "static-1.1892",
  "messaging-editing-lib": "static-1.46121",
  "messaging-usage-based-billing-components-lib": "static-1.983",
  "automation-ui-source-apps": "static-1.18728",
  "automation-ui-types": "static-1.19646",
  "messaging-types-lib": "static-1.45858",
  "onboarding-settings-client": "static-1.4460",
  "sequences-client-types-lib": "static-1.7817",
  "commerce-tax-lib": "static-1.481",
  "price-books-api": "static-1.470",
  "price-books-components": "static-1.528",
  "property-description-translator": "static-1.3804",
  "ramp-editor": "static-1.47",
  "commerce-analytics-service-client": "static-1.3585",
  "totals-ui-components": "static-1.23447",
  "SalesContentIndexUI": "static-3.9175",
  "advanced-menus-core": "static-1.15055",
  "advanced-menus-lib": "static-1.12006",
  "ui-memberships-settings-lib": "static-1.33914",
  "segments-query-core": "static-1.1372",
  "demographics-service-types": "static-1.1610",
  "eligibility-engine-service-types": "static-1.3142",
  "automation-ui-ubb": "static-1.5562",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7297",
  "data-token-views": "static-1.16305",
  "forms-utils-lib": "static-1.12492",
  "payments-embed-points-lib": "static-1.12933",
  "simple-menus-core": "static-1.15054",
  "simple-menus-lib": "static-1.16571",
  "ui-addon-draggable-compat": "static-2.4212",
  "videoconference-integration-components": "static-1.6750",
  "marketing-contacts-client": "static-1.7476",
  "automation-applications-service-types": "static-1.3465",
  "automation-platform-service-types": "static-1.2565",
  "ContentEditorUI": "static-2.76980",
  "short-messages-app-service-client": "static-1.3939",
  "web-interactives-components": "static-1.13680",
  "web-interactives-data": "static-1.13681",
  "messaging-shared-utils-lib": "static-1.432",
  "messaging-user-info-utils-lib": "static-1.602",
  "email-portal-health-service-types": "static-1.934",
  "line-items-api": "static-1.621",
  "commerce-totals-service-types": "static-1.3783",
  "FireAlarmUi": "static-1.4478",
  "sales-templates-service-types-lib": "static-1.4132",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21582",
  "automation-ui-usage-tracking": "static-1.21045",
  "data-studio-ubb": "static-1.2578",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26889",
  "collaboration-sidebar": "static-1.57649",
  "content-management-data-lib": "static-1.5327",
  "copilot-plugins": "static-1.10964",
  "cta-picker": "static-1.36274",
  "customer-agent-discovery-components-lib": "static-1.2942",
  "editor-components": "static-1.13166",
  "editor-iframe-lib": "static-1.8338",
  "error-messaging-js": "static-1.5149",
  "FormsCommonComponents": "static-1.85701",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10604",
  "SharedLegalStrings": "static-1.1704",
  "smart-content-core": "static-1.42303",
  "smart-content-lib": "static-1.42956",
  "social-composer-lib": "static-1.58901",
  "structured-content-lib": "static-1.25061",
  "theme-previewer-lib": "static-1.53119",
  "tinymce-copilot": "static-1.16299",
  "xray-recommendation-lib": "static-1.7839",
  "automation-ui-routing": "static-1.21003",
  "sql-reporting-client-types": "static-1.5597",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42067",
  "campaigns-utils-lib": "static-1.3129",
  "reporting-enablement": "static-1.22738",
  "chatspot-widget-iframe": "static-1.21047",
  "collaboration-sidebar-common": "static-1.2446",
  "forms-ai-lib": "static-1.4244",
  "codemirror-dlb": "static-1.58539",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6387",
  "report-customization-components": "static-1.13032",
  "data-quality-ui-library": "static-1.12791",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.193",
  "reporting-insights-lib": "static-1.1589"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12091",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.461",
  "dashboard-client-types": "/dashboard-client-types/static-1.351",
  "data-fetching-client": "/data-fetching-client/static-1.9632",
  "foundations-components": "/foundations-components/static-1.7844",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.869",
  "foundations-theming": "/foundations-theming/static-1.4374",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7974",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9854",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11419",
  "I18n": "/I18n/static-7.1612",
  "jasmine-runner": "/jasmine-runner/static-1.6427",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12152",
  "quartz": "/quartz/static-1.6964",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16626",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2817",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.42",
  "settings-ui-lib": "/settings-ui-lib/static-1.12479",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7050",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11108",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9503",
  "unified-auth": "/unified-auth/static-1.435",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.716",
  "usage-tracker": "/usage-tracker/static-1.7297",
  "usage-tracker-core": "/usage-tracker-core/static-1.7147",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8041",
  "hub-http": "/hub-http/static-1.6179",
  "integrations-lib": "/integrations-lib/static-1.15963",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19534",
  "property-management-iframe": "/property-management-iframe/static-1.12992",
  "quartz-config": "/quartz-config/static-1.742",
  "quartz-core": "/quartz-core/static-1.6183",
  "quartz-routing": "/quartz-routing/static-1.394",
  "quick-fetch": "/quick-fetch/static-1.3881",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4608",
  "ts-schema": "/ts-schema/static-1.4042",
  "ui-universal-auth": "/ui-universal-auth/static-1.8921",
  "UIComponents": "/UIComponents/static-3.8366",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3368",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3241",
  "quartz-webpack": "/quartz-webpack/static-1.3188",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.42",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4113",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4814",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2090",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9387",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.11",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5308",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1710",
  "ui-fonts": "/ui-fonts/static-1.681",
  "ui-images": "/ui-images/static-2.1141",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2857",
  "foundations-theming-base": "/foundations-theming-base/static-1.3359",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.741",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3085",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4282",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8812",
  "ai-rendering-library": "/ai-rendering-library/static-1.9938",
  "chirp-fetch": "/chirp-fetch/static-1.1843",
  "connections-embed-lib": "/connections-embed-lib/static-1.910",
  "copilot-toolkit": "/copilot-toolkit/static-1.10991",
  "feedback-loader": "/feedback-loader/static-1.29213",
  "laboratory-lib": "/laboratory-lib/static-3.7116",
  "marketplace-embed": "/marketplace-embed/static-1.21932",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9430",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19490",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13705",
  "sanitize-text": "/sanitize-text/static-1.8101",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8656",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5711",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4983",
  "wootric-nps": "/wootric-nps/static-1.6943",
  "quartz-head": "/quartz-head/static-1.629",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4606",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4111",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2472",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.42",
  "cssUtils": "/cssUtils/static-1.780",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11727",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10168",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10329",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7287",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18067",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4473",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5327",
  "quartz-i18n": "/quartz-i18n/static-1.639",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.94",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.207",
  "fsm": "/fsm/static-1.3690",
  "customer-data-objects": "/customer-data-objects/static-1.7621",
  "property-translator": "/property-translator/static-1.5359",
  "hs-locale-management": "/hs-locale-management/static-1.48",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7885",
  "hs-promise-utils": "/hs-promise-utils/static-1.5551",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4834",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13378",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5556",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7741",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4430",
  "superstore": "/superstore/static-1.4724",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10106",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7811",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "hubspotter-http": "/hubspotter-http/static-1.4616",
  "immutable-less": "/immutable-less/static-1.4607",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16941",
  "nav-meta": "/nav-meta/static-1.29509",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10203",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17923",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3805",
  "property-management-common": "/property-management-common/static-1.5280",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9013",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.639",
  "quartz-test": "/quartz-test/static-1.639",
  "quartz-tracking": "/quartz-tracking/static-1.343",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.18",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3555",
  "persist-promise": "/persist-promise/static-1.3664",
  "reference-resolvers": "/reference-resolvers/static-1.8128",
  "transmute": "/transmute/static-2.85",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21056",
  "ContentUtils": "/ContentUtils/static-1.68222",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12983",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2456",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39581",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13117",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14176",
  "ExportDialog": "/ExportDialog/static-6.10351",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41171",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.42",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.42",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.42",
  "ui-addon-teams": "/ui-addon-teams/static-1.21488",
  "magpie-lib": "/magpie-lib/static-1.5532",
  "navigation-components": "/navigation-components/static-1.17872",
  "magpie-types": "/magpie-types/static-1.4992",
  "simple-logging-lib": "/simple-logging-lib/static-1.3007",
  "ai-studio-lib": "/ai-studio-lib/static-1.11459",
  "app-governance-lib": "/app-governance-lib/static-1.1387",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10467",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7954",
  "ui-product-approvals": "/ui-product-approvals/static-1.28005",
  "ui-tool-access": "/ui-tool-access/static-1.10107",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8637",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5714",
  "usage-tracker-public": "/usage-tracker-public/static-1.7108",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3886",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.293",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2970",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2640",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5030",
  "purchase-motions-components": "/purchase-motions-components/static-1.5801",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1507",
  "crm-component-utils": "/crm-component-utils/static-1.38950",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5834",
  "customer-data-properties": "/customer-data-properties/static-1.51378",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6836",
  "property-value-citations": "/property-value-citations/static-1.1992",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8053",
  "navigation-messaging": "/navigation-messaging/static-1.7199",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9852",
  "growth-payments-core": "/growth-payments-core/static-1.25225",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13534",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7206",
  "crm-message-bus": "/crm-message-bus/static-1.42856",
  "reporting-plugins": "/reporting-plugins/static-1.10214",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.42",
  "cms-field-types": "/cms-field-types/static-1.4769",
  "content-icons-ui": "/content-icons-ui/static-1.2214",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9784",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22016",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4677",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3974",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6741",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.937",
  "onboarding-tours": "/onboarding-tours/static-1.16509",
  "academy-common-lib": "/academy-common-lib/static-1.13636",
  "content-assistance-lib": "/content-assistance-lib/static-1.7681",
  "dashboard-lib": "/dashboard-lib/static-1.81334",
  "file-manager-components": "/file-manager-components/static-1.23487",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18360",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18098",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18090",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19751",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8655",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4727",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10966",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9006",
  "user-context": "/user-context/static-1.5059",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.679",
  "nest": "/nest/static-1.185",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10581",
  "framework-listing-lib": "/framework-listing-lib/static-2.28542",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30589",
  "apps-service-types": "/apps-service-types/static-1.3835",
  "oauth-service-types": "/oauth-service-types/static-1.4207",
  "onboarding-scopes": "/onboarding-scopes/static-1.6420",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4723",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7637",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14857",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3574",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9100",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5804",
  "signup-constants": "/signup-constants/static-1.18758",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7998",
  "trials-service-types": "/trials-service-types/static-1.3861",
  "card-properties-lib": "/card-properties-lib/static-1.44029",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36959",
  "crm-actions": "/crm-actions/static-1.6277",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43436",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9181",
  "customer-data-tracking": "/customer-data-tracking/static-1.6843",
  "hs-resources": "/hs-resources/static-1.106",
  "pulse": "/pulse/static-1.518",
  "calling-global-api": "/calling-global-api/static-1.64343",
  "calling-internal-common": "/calling-internal-common/static-1.31259",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65725",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58019",
  "commerce-products-lib": "/commerce-products-lib/static-1.9352",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3761",
  "crm-links": "/crm-links/static-1.6241",
  "external-options-client-types": "/external-options-client-types/static-1.4123",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4188",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.589",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3656",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48572",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3930",
  "smart-property-lib": "/smart-property-lib/static-1.6689",
  "tiered-pricing": "/tiered-pricing/static-1.1113",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10946",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4107",
  "ui-addon-opt": "/ui-addon-opt/static-4.8330",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8934",
  "react-dnd-compat": "/react-dnd-compat/static-1.4578",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5354",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3025",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1772",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.575",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7487",
  "academy-service-client": "/academy-service-client/static-1.3640",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.38986",
  "FileManagerLib": "/FileManagerLib/static-1.39127",
  "video-embed": "/video-embed/static-1.35601",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28409",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11109",
  "video-data-lib": "/video-data-lib/static-1.34767",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23399",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9846",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24272",
  "viral-links-lib": "/viral-links-lib/static-1.7013",
  "data-token-picker": "/data-token-picker/static-1.16324",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.183",
  "timezone-utils": "/timezone-utils/static-2.5202",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17478",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7283",
  "customer-data-views-management": "/customer-data-views-management/static-1.25361",
  "framework-data-table": "/framework-data-table/static-2.11811",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6809",
  "nudge-client-utils": "/nudge-client-utils/static-1.2458",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.951",
  "app-users-service-client": "/app-users-service-client/static-1.5551",
  "app-users-service-types": "/app-users-service-types/static-1.4959",
  "mini-checkout-client": "/mini-checkout-client/static-1.26687",
  "onboarding-utils": "/onboarding-utils/static-1.5309",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2042",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28394",
  "edison-service-client-types": "/edison-service-client-types/static-1.344",
  "crm_data": "/crm_data/static-4.91803",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45863",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15807",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18928",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18381",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10245",
  "crm-fe-perf": "/crm-fe-perf/static-1.22861",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.21",
  "directed-graph": "/directed-graph/static-1.893",
  "event-emitter": "/event-emitter/static-1.906",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31265",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10995",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6500",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.793",
  "commerce-permissions": "/commerce-permissions/static-1.723",
  "products-iframe-lib": "/products-iframe-lib/static-1.7787",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10236",
  "data-agent-kit": "/data-agent-kit/static-1.120",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9937",
  "policy-lib": "/policy-lib/static-1.6730",
  "react-tinymce": "/react-tinymce/static-1.55105",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10000",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54231",
  "tinymce-plugins": "/tinymce-plugins/static-1.57345",
  "tinymce-themes": "/tinymce-themes/static-1.56201",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1885",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1800",
  "user-context-client": "/user-context-client/static-1.4568",
  "audio-components": "/audio-components/static-1.5846",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36638",
  "urlinator": "/urlinator/static-1.4489",
  "video-components": "/video-components/static-1.13112",
  "outpost": "/outpost/static-1.4145",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6541",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12089",
  "content-media-compositions": "/content-media-compositions/static-2.16096",
  "media-bridge-lib": "/media-bridge-lib/static-1.18847",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6008",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5039",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3597",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21591",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3801",
  "ts-utils-lib": "/ts-utils-lib/static-1.131",
  "crm-export-dialog": "/crm-export-dialog/static-1.6256",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6396",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1850",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2215",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2534",
  "whisper-core-api": "/whisper-core-api/static-1.6468",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14666",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5397",
  "settings-content-modals": "/settings-content-modals/static-1.45938",
  "crm_universal": "/crm_universal/static-1.21926",
  "customer-data-email": "/customer-data-email/static-1.17953",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37024",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39382",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11881",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54559",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21325",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17636",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71812",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5296",
  "utility-belt": "/utility-belt/static-1.2495",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22547",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7421",
  "customer-data-rte": "/customer-data-rte/static-1.32870",
  "cv-backend-services": "/cv-backend-services/static-1.1551",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5633",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5067",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37902",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35570",
  "sales-views-client-types": "/sales-views-client-types/static-1.4222",
  "hub-http-contrib": "/hub-http-contrib/static-1.2998",
  "interframe": "/interframe/static-3.4719",
  "tinymce-data": "/tinymce-data/static-1.40316",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5168",
  "layout-dnd-components": "/layout-dnd-components/static-1.12355",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11330",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15041",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9027",
  "social-insights-client-types": "/social-insights-client-types/static-1.21954",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1854",
  "checkout-sdk": "/checkout-sdk/static-3.23530",
  "checkout-service-types": "/checkout-service-types/static-1.3791",
  "company-details-components": "/company-details-components/static-1.6154",
  "payment-method-components": "/payment-method-components/static-1.6870",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13656",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3438",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3482",
  "access-control-lib": "/access-control-lib/static-1.10395",
  "EmailComponents": "/EmailComponents/static-1.54634",
  "EmailData": "/EmailData/static-1.53311",
  "redux-less": "/redux-less/static-2.9441",
  "sequences-lib": "/sequences-lib/static-1.7960",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10305",
  "products-ui-components": "/products-ui-components/static-1.39871",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6988",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54575",
  "commerce-products-api": "/commerce-products-api/static-1.2220",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56633",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102490",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80533",
  "stripe-connect-js": "/stripe-connect-js/static-1.67",
  "draft-content-plugins": "/draft-content-plugins/static-1.28138",
  "ContentData": "/ContentData/static-1.68297",
  "layout-data-lib": "/layout-data-lib/static-1.9655",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.793",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3890",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3948",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.516",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18511",
  "pricing-pages-api": "/pricing-pages-api/static-1.13521",
  "ContentComponents": "/ContentComponents/static-2.71178",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9810",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1892",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46121",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.983",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18728",
  "automation-ui-types": "/automation-ui-types/static-1.19646",
  "messaging-types-lib": "/messaging-types-lib/static-1.45858",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4460",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7817",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.481",
  "price-books-api": "/price-books-api/static-1.470",
  "price-books-components": "/price-books-components/static-1.528",
  "property-description-translator": "/property-description-translator/static-1.3804",
  "ramp-editor": "/ramp-editor/static-1.47",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3585",
  "totals-ui-components": "/totals-ui-components/static-1.23447",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9175",
  "advanced-menus-core": "/advanced-menus-core/static-1.15055",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12006",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33914",
  "segments-query-core": "/segments-query-core/static-1.1372",
  "demographics-service-types": "/demographics-service-types/static-1.1610",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3142",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5562",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7297",
  "data-token-views": "/data-token-views/static-1.16305",
  "forms-utils-lib": "/forms-utils-lib/static-1.12492",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12933",
  "simple-menus-core": "/simple-menus-core/static-1.15054",
  "simple-menus-lib": "/simple-menus-lib/static-1.16571",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4212",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6750",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7476",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3465",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2565",
  "ContentEditorUI": "/ContentEditorUI/static-2.76980",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3939",
  "web-interactives-components": "/web-interactives-components/static-1.13680",
  "web-interactives-data": "/web-interactives-data/static-1.13681",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.432",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.602",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.934",
  "line-items-api": "/line-items-api/static-1.621",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3783",
  "FireAlarmUi": "/FireAlarmUi/static-1.4478",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4132",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21582",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21045",
  "data-studio-ubb": "/data-studio-ubb/static-1.2578",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26889",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57649",
  "content-management-data-lib": "/content-management-data-lib/static-1.5327",
  "copilot-plugins": "/copilot-plugins/static-1.10964",
  "cta-picker": "/cta-picker/static-1.36274",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2942",
  "editor-components": "/editor-components/static-1.13166",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8338",
  "error-messaging-js": "/error-messaging-js/static-1.5149",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85701",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10604",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1704",
  "smart-content-core": "/smart-content-core/static-1.42303",
  "smart-content-lib": "/smart-content-lib/static-1.42956",
  "social-composer-lib": "/social-composer-lib/static-1.58901",
  "structured-content-lib": "/structured-content-lib/static-1.25061",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53119",
  "tinymce-copilot": "/tinymce-copilot/static-1.16299",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7839",
  "automation-ui-routing": "/automation-ui-routing/static-1.21003",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5597",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42067",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3129",
  "reporting-enablement": "/reporting-enablement/static-1.22738",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21047",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2446",
  "forms-ai-lib": "/forms-ai-lib/static-1.4244",
  "codemirror-dlb": "/codemirror-dlb/static-1.58539",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6387",
  "report-customization-components": "/report-customization-components/static-1.13032",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12791",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.193",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1589"
}
};
